import { render, staticRenderFns } from "./ImageInformation.vue?vue&type=template&id=2ffeee81&scoped=true"
import script from "./ImageInformation.vue?vue&type=script&lang=js"
export * from "./ImageInformation.vue?vue&type=script&lang=js"
import style0 from "./ImageInformation.vue?vue&type=style&index=0&id=2ffeee81&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ffeee81",
  null
  
)

export default component.exports